import { Injectable } from '@angular/core';
import { Router, Params, ActivatedRoute, ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Outlet } from './outlet.model';
import { OutletService } from './outlet.service';


@Injectable()
export class OutletListGuard implements Resolve<Outlet> {

  constructor(public router: Router, private usersService: OutletService) { }

  resolve() {
    return this.usersService.getOutletList();
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/outlet/outlet-list.guard.ts